import { Observable } from 'rxjs/Observable';
import ajax from '@ui/services/api/ajax';
import { IFocus } from '@ui/store/meta/actions';
import { map } from 'rxjs/operators';

export interface StoreApi {
  getStoresByCityId: (cityId: string) => Observable<any>;
  removeStoreById: (storeId: string) => Observable<any>;
  editStore: (store: any) => Observable<any>;
  getFactories: () => Observable<any>;
  getMarkets: () => Observable<any>;
  createStore: (store: any) => Observable<any>;
  uploadPhoto: (id: any, file: any) => Observable<any>;
  getStoreById: (storeId: string) => Observable<any>;
  createMarket: (market: any) => Observable<any>;
  updateComment: (storeId: string, comment: string) => Observable<any>;
  updateFocus: (focus: IFocus) => Observable<any>;
  updateStoreInfo: (id: string, store: any) => Observable<any>;
}

export const storeApi: StoreApi = {
  getStoresByCityId: (cityId: string) => ajax.get({ url: 'store/city-stores', params: { cityId } }),

  removeStoreById: (storeId) => ajax.post({ url: 'store/remove', body: { storeId } }),

  editStore: (store: any) => {
    if (store.idLotus && typeof store.idLotus === 'string') {
      store.idLotus = store.idLotus.trim();
    }
    return ajax.post({
      url: 'store/edit',
      body: { store: JSON.stringify(store) },
    })
  },

  getFactories: () => ajax.get({ url: 'store/factories' }),

  getMarkets: () =>
    ajax.get({ url: 'markets' }).pipe(
      map((v) => ({
        markets: v,
      })),
    ),

  createStore: (store: any) => {
    if (store.idLotus && typeof store.idLotus === 'string') {
      store.idLotus = store.idLotus.trim();
    }
    return ajax.post({
      url: 'store/create',
      body: { store: JSON.stringify(store) },
    })
  },

  createMarket: (market: any) =>
    ajax.post({
      url: 'markets/create-market',
      body: { market: JSON.stringify(market) },
    }),

  uploadPhoto: (id: any, file: any) => {
    const formData = new FormData();
    formData.append('file', file.file);

    return ajax.post({
      url: `store/${id}/upload-photo`,
      body: formData,
    });
  },

  getStoreById: (storeId) => ajax.get({ url: `store/store/${storeId}` }),

  updateComment: (id: string, comment: string) => {
    return ajax.patch({
      url: `store/${id}/update-comment`,
      body: {
        comment,
      },
    });
  },

  updateStoreInfo: (id: string, store: any) => {
    return ajax.patch({
      url: `store/${id}/update-info`,
      body: {
        info: JSON.stringify({
          address: store.address,
          phone: store.phone,
          mail: store.mail,
          firstName: store.firstName,
          lastName: store.lastName,
          middleName: store.middleName,
          firstContactPhone: store.firstContactPhone,
          secondContactPhone: store.secondContactPhone,
          name: store.name,
          // factories: store.factories,
        }),
      },
    });
  },

  updateFocus: (focus: IFocus) => {
    return ajax.post({
      url: 'focus',
      body: focus,
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/store/store.ts